module.exports = __webpack_public_path__ + "assets/img/186301.4dc12d39.png";